RivalIQ.apps.Admin.apps.Account.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.UserSearchResults = Marionette.CompositeView.extend({
        tagName: 'table',
        className: 'table',
        template: '#userSearchResultsTemplate',
        childViewContainer: 'tbody',
        childView: views.UserSearchResult,
        emptyView: RivalIQ.apps.Admin.views.EmptyResults,

        childViewOptions: function () {
            const me = this;
            return {
                adminEditingProperties: me.options.adminEditingProperties
            };
        },

        addChild: function (child, ChildView, index) {
            const me = this;
            const addChild = Marionette.CollectionView.prototype.addChild;
            if (index < 10) {
                addChild.apply(this, arguments);
            } else {
                const render = _.bind(addChild, me, child, ChildView, index);
                _.defer(render);
            }
        }
    });
});
